import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NotificationPreferences {
  enabled: boolean;
  morning: {
    enabled: boolean;
    time: number; // hour (0-23)
  };
  evening: {
    enabled: boolean;
    time: number; // hour (0-23)
  };
}

interface SettingsState {
  darkMode: boolean;
  language: string;
  notifications: boolean;
  notificationPreferences: NotificationPreferences | null;
  setDarkMode: (darkMode: boolean) => void;
  setLanguage: (lang: string) => void;
  setNotifications: (enabled: boolean) => void;
  setNotificationPreferences: (preferences: NotificationPreferences) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      darkMode: false,
      language: 'es',
      notifications: true,
      notificationPreferences: null,
      setDarkMode: (darkMode) => set({ darkMode }),
      setLanguage: (language) => set({ language }),
      setNotifications: (notifications) => set({ notifications }),
      setNotificationPreferences: (notificationPreferences) => set({ notificationPreferences }),
    }),
    {
      name: 'settings-storage',
    }
  )
);